/**
 * @ Author: Housefolios
 * @ Create Time: 2023-01-09 15:48:40
 * @ Modified by: David Helmick
 * @ Modified time: 2024-11-21 19:37:52
 * @ Description: cards with rental comp information
 */

import {
  strategyCompImgFluidSx,
  strategyFont16SemiboldSx,
  strategyFont16Sx,
  strategyFullHeight100Sx,
  strategyMarginTop10OnlySx,
  strategyMarginTopBottom10Sx,
  strategyPad10Sx,
  strategyPrice26Sx,
  strategyTextRightSx,
  strategyTransparentCenterSx,
} from '@/housefolios-components/PropertyContainer/CenterPage/Common/strategyDashboardSx'
import { compMarkerColor } from '@/housefolios-components/PropertyContainer/CenterPage/compMarkerColors'
import React, { useEffect, useState } from 'react'

// Centralized lodash imports - much cleaner!
import { includes, isEmpty, merge } from '@/utils/lodash'

import Slider1 from 'react-slick'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  Grid,
  Avatar,
  Card,
  CardContent,
  Checkbox,
  Slider,
  Typography,
  IconButton,
  Button,
  Box,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'

import { UPDATE_COMPPROPERTY } from '@/housefolios-components/PropertyContainer/mutations'
import { GET_COMPPROPERTIES } from '@/housefolios-components/PropertyContainer/queries'
import { DEFAULT_PREFERENCES } from '@/housefolios-components/OrganizationSettings/OrganizationPreferences'
import { useMutation } from '@apollo/client/react'
import withSession from '@/housefolios-components/Session/withSession'

var months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

function SliderArrowNext(props) {
  const { className, onClick } = props
  return (
    <div className={className} onClick={onClick}>
      <FontAwesomeIcon icon={['fas', 'chevron-right']} />
    </div>
  )
}

function SliderArrowPrev(props) {
  const { className, onClick } = props
  return (
    <div className={className} onClick={onClick}>
      <FontAwesomeIcon icon={['fas', 'chevron-left']} />
    </div>
  )
}

function CenterPageCompsCardComponent(props) {
  const { openEdit, comp, property } = props
  const sessionOrg =
    props.session?.me?.activeOrg ||
    property?.portfolio?.organization
  const theme = useTheme()
  const isDark = theme.palette.mode === 'dark'
  const cardBg = theme.palette.background.paper
  const metricsBg = isDark ? 'rgba(255, 255, 255, 0.08)' : '#eff2f5'
  const mutedLabel = isDark ? 'rgba(255, 255, 255, 0.6)' : '#949798'
  const valueColor = theme.palette.text.primary

  const currencyFormat = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })

  const percentageFormat = new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 0,
  })

  const numberFormat = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })

  const widgetsCarousels1B = {
    dots: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
    nextArrow: <SliderArrowNext />,
    prevArrow: <SliderArrowPrev />,
  }

  const [inputAdjustment, setInputAdjustment] = useState(
    comp.priceAdjustment,
  )

  useEffect(() => {
    setInputAdjustment(comp.priceAdjustment)
  }, [comp])

  const [updateCompProperty] = useMutation(UPDATE_COMPPROPERTY)

  const onChangeSlider = (
    event,
    value,
    name,
    updateCompProperty = null,
  ) => {
    setInputAdjustment(value)
    if (updateCompProperty) {
      updateCompProperty({
        variables: {
          id: comp._id,
          compPropertyInput: {
            priceAdjustment: Number(value),
          },
        },
        refetchQueries: [
          {
            query: GET_COMPPROPERTIES,
            variables: { propertyId: property._id },
          },
        ],
      })
    }
  }

  return (
    <Box sx={{ display: 'flex', minWidth: 0, width: '100%' }}>
      <Box sx={[{ backgroundColor: cardBg, width: '100%' }, {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        minWidth: 0,
        backgroundColor: "#fff",
        borderRadius: "0.65rem",
        boxShadow: "0 0.46875rem 2.1875rem rgba(59, 62, 102, 0.03), 0 0.9375rem 1.40625rem rgba(59, 62, 102, 0.03), 0 0.25rem 0.53125rem rgba(59, 62, 102, 0.05), 0 0.125rem 0.1875rem rgba(59, 62, 102, 0.03)",
        "button&": { outline: "none" },
        wordWrap: "break-word",
        backgroundClip: "border-box",
        border: "0 solid rgba(79, 80, 98, 0.3)",
        "html[data-color-mode=\"dark\"] &": { backgroundColor: "#1e1e1e !important", color: "rgba(255, 255, 255, 0.87)" },
        transition: "all 0.2s ease-in-out !important",
        "&:hover": { boxShadow: "0 0.56875rem 3.3875rem rgba(59, 62, 102, 0.05), 0 0.9975rem 2.40625rem rgba(59, 62, 102, 0.07), 0 0.35rem 1.23125rem rgba(59, 62, 102, 0.05), 0 0.225rem 1.1875rem rgba(59, 62, 102, 0.09)", transform: "translateY(-15px)" },
        "&.card-box-hover:hover": { boxShadow: "0 0.56875rem 3.3875rem rgba(59, 62, 102, 0.05), 0 0.9975rem 2.40625rem rgba(59, 62, 102, 0.07), 0 0.35rem 1.23125rem rgba(59, 62, 102, 0.05), 0 0.225rem 1.1875rem rgba(59, 62, 102, 0.09)", transform: "translateY(0)" },
      }]}>
        <Slider1 {...widgetsCarousels1B} sx={{ flexShrink: 0, width: "100%" }}>
          {comp.rentalImage ? (
            <div
              onClick={(event) => {
                event.stopPropagation()
              }}
            >
              <Card sx={[{
                  height: 325,
                  backgroundColor: cardBg,
                  margin: '1px',
                }, { boxShadow: 'none' }]}>
                <Grid
                  container
                  direction="column" sx={[strategyFullHeight100Sx, {
                    justifyContent: 'center',
                  }]}>
                  <Grid>
                    <Box onClick={ props.shared ? null : () => openEdit(comp) } sx={[strategyTransparentCenterSx, {
                      position: "relative",
                      borderTopLeftRadius: "inherit",
                      borderTopRightRadius: "inherit",
                      "& .img-wrapper-overlay": {
                        width: "100%",
                        height: "100%",
                        transition: "all 0.2s ease-in-out",
                        opacity: 0,
                        visibility: "hidden",
                        position: "absolute",
                        left: 0,
                        top: 0,
                        boxShadow: "inset 0 0 2.3rem 0.5rem #000",
                        display: "flex",
                        alignItems: "center",
                        alignContent: "center",
                        color: "#fff",
                        borderTopLeftRadius: "inherit",
                        borderTopRightRadius: "inherit",
                        "@media (max-width: 575.98px)": {
                          "& + img": { width: "100% !important" },
                        },
                        "& .overlay-btn-wrapper": {
                          position: "relative",
                          zIndex: 3,
                          textAlign: "center",
                          width: "100%",
                        },
                        "&::before": {
                          zIndex: 2,
                          position: "absolute",
                          left: 0,
                          top: 0,
                          content: "\"\"",
                          width: "100%",
                          height: "100%",
                          transition: "all 0.2s ease-in-out",
                          background: "#000",
                          opacity: 0.75,
                        },
                      },
                      "& .img-wrapper-overlay--visible": {
                        visibility: "visible",
                        opacity: 1,
                        position: "relative",
                        zIndex: 5,
                      },
                      "& .card-badges": { zIndex: 5 },
                      "a&": {
                        display: "block",
                        overflow: "hidden",
                        "&:hover .img-wrapper-overlay": { opacity: 1, visibility: "visible" },
                      },
                    }]}>
                      <Box component="img" src={comp.rentalImage} alt="..." sx={[strategyCompImgFluidSx, { borderRadius: '0.65rem' }, { flexShrink: 0, width: "100%" }]}/>
                    </Box>
                  </Grid>
                </Grid>
              </Card>
            </div>
          ) : (
            <div
              onClick={(event) => {
                event.stopPropagation()
              }}
            >
              <Card sx={[{
                  height: 325,
                  backgroundColor: cardBg,
                  margin: '1px',
                }, { boxShadow: 'none' }]}>
                <Grid
                  container
                  direction="column" sx={[strategyFullHeight100Sx, {
                    justifyContent: 'center',
                  }]}>
                  <Grid>
                    <Box onClick={ props.shared ? null : () => openEdit(comp) } sx={[strategyTransparentCenterSx, {
                      position: "relative",
                      borderTopLeftRadius: "inherit",
                      borderTopRightRadius: "inherit",
                      "& .img-wrapper-overlay": {
                        width: "100%",
                        height: "100%",
                        transition: "all 0.2s ease-in-out",
                        opacity: 0,
                        visibility: "hidden",
                        position: "absolute",
                        left: 0,
                        top: 0,
                        boxShadow: "inset 0 0 2.3rem 0.5rem #000",
                        display: "flex",
                        alignItems: "center",
                        alignContent: "center",
                        color: "#fff",
                        borderTopLeftRadius: "inherit",
                        borderTopRightRadius: "inherit",
                        "@media (max-width: 575.98px)": {
                          "& + img": { width: "100% !important" },
                        },
                        "& .overlay-btn-wrapper": {
                          position: "relative",
                          zIndex: 3,
                          textAlign: "center",
                          width: "100%",
                        },
                        "&::before": {
                          zIndex: 2,
                          position: "absolute",
                          left: 0,
                          top: 0,
                          content: "\"\"",
                          width: "100%",
                          height: "100%",
                          transition: "all 0.2s ease-in-out",
                          background: "#000",
                          opacity: 0.75,
                        },
                      },
                      "& .img-wrapper-overlay--visible": {
                        visibility: "visible",
                        opacity: 1,
                        position: "relative",
                        zIndex: 5,
                      },
                      "& .card-badges": { zIndex: 5 },
                      "a&": {
                        display: "block",
                        overflow: "hidden",
                        "&:hover .img-wrapper-overlay": { opacity: 1, visibility: "visible" },
                      },
                    }]}>
                      <Box component="img" src="/images/default_image.png" alt="..." sx={[strategyCompImgFluidSx, { borderRadius: '0.65rem' }, { flexShrink: 0, width: "100%" }]}/>
                    </Box>
                  </Grid>
                </Grid>
              </Card>
            </div>
          )}
        </Slider1>
        <Box sx={[{ left: 'auto', right: 8, backgroundColor: 'transparent', boxShadow: 'transparent', }, { position: "absolute", left: "1rem", top: "0.5rem" }]}>
          <Grid
            container
            spacing={1} sx={[strategyTextRightSx, { justifyContent: 'flex-end' }]}>
            {!props.shared && (
              <Grid>
                <IconButton
                  onClick={props.selectComp(comp._id)}
                  size="large"
                >
                  <Checkbox
                    checked={includes(props.selected, comp._id)} sx={{
                      height: 20,
                      width: 20,
                      backgroundColor: cardBg,
                      borderRadius: 0,
                    }}/>
                </IconButton>
              </Grid>
            )}
            <Grid>
              <Avatar sx={{
                  height: 30,
                  width: 30,
                  backgroundColor: compMarkerColor(props.potential),
                  color: '#fff',
                }}>
                {props.index + 1}
              </Avatar>
            </Grid>
          </Grid>
        </Box>
        {/* <div>
          <Button variant="text">
            <FontAwesomeIcon icon={['far', 'square']} />
          </Button>
        </div> */}
        <CardContent>
          <Grid container direction="column">
            <Grid>
              <Grid
                container
                wrap="nowrap"
                sx={{
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Grid>
                  {/* <Typography sx={strategyPrice26Sx}>{currencyFormat.format(comp.estval)}</Typography> */}
                </Grid>
                <Grid>
                  <Typography sx={strategyFont16Sx}>
                    {comp.beds} bd | {comp.baths} ba | Accommodates{' '}
                    {comp.accommodates}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid>
              <Grid
                container
                wrap="nowrap"
                sx={{
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Grid>
                  <Typography
                   
                    noWrap={true} sx={strategyFont16SemiboldSx}>
                    {comp.city}, {comp.state} {comp.zip}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid sx={strategyMarginTopBottom10Sx}>
              <Card sx={{ backgroundColor: metricsBg }}>
                <CardContent sx={strategyPad10Sx}>
                  <Grid
                    container
                    direction="row"
                    sx={{
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                      gap: 1,
                      "& > *": { flex: "1 1 96px", minWidth: 0 },
                    }}
                  >
                    <Grid>
                      <Grid
                        container
                        direction="column"
                        sx={{
                          alignItems: 'center',
                        }}
                      >
                        <Grid>
                          <Typography sx={{
                              whiteSpace: 'nowrap',
                              color: mutedLabel,
                              fontWeight: 600,
                            }}>
                            Avg Daily Rate
                          </Typography>
                        </Grid>
                        <Grid>
                          <Typography sx={{
                              whiteSpace: 'nowrap',
                              color: '#008bff',
                              fontWeight: 600,
                            }}>
                            {currencyFormat.format(comp.rentalPrice)}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid>
                      <Grid
                        container
                        direction="column"
                        sx={{
                          alignItems: 'center',
                        }}
                      >
                        <Grid>
                          <Typography sx={{
                              whiteSpace: 'nowrap',
                              color: mutedLabel,
                              fontWeight: 600,
                            }}>
                            Occupancy Rate
                          </Typography>
                        </Grid>
                        <Grid>
                          <Typography sx={{
                              whiteSpace: 'nowrap',
                              color: valueColor,
                              fontWeight: 600,
                            }}>
                            {comp.occupancyRate
                              ? percentageFormat.format(
                                  comp.occupancyRate,
                                )
                              : '-'}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid>
                      <Grid
                        container
                        direction="column"
                        sx={{
                          alignItems: 'center',
                        }}
                      >
                        <Grid>
                          <Typography sx={{
                              whiteSpace: 'nowrap',
                              color: mutedLabel,
                              fontWeight: 600,
                            }}>
                            Distance
                          </Typography>
                        </Grid>
                        <Grid>
                          <Typography sx={{
                              whiteSpace: 'nowrap',
                              fontWeight: 600,
                              color:
                                parseFloat(
                                  merge(
                                    DEFAULT_PREFERENCES,
                                    sessionOrg?.preferences,
                                  ).findComps.maxDistance,
                                ) < comp.distance && comp.potential
                                  ? '#f4772e'
                                  : valueColor,
                            }}>
                            {numberFormat.format(comp.distance)} miles
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid sx={strategyMarginTop10OnlySx}>
              <Button
                fullWidth
                variant="outlined"
                onClick={(event) =>
                  window.open(
                    comp.rentalURL,
                    '_blank',
                    'toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400',
                  )
                }
              >
                AIRBNB
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Box>
    </Box>
  )
}

export default withSession(CenterPageCompsCardComponent)
